<script lang="ts" setup>
import { computed } from "vue"

type Props = {
    step: number
    title: string
    progress: number
}

const props = withDefaults(defineProps<Props>(), {
    step: 0,
    title: "",
    progress: 0,
})

const getColorIcon = computed(() => {
    return props.progress === 100 ? "#A1EC7E" : "#E3E3E3"
})

const getColorProgress = computed(() => {
    return props.progress === 100 ? "#A1EC7E" : "#1D6EE7"
})
</script>

<template>
    <div class="form-stepper-item">
        <h5>Étape {{ step }}</h5>
        <h3>
            {{ title
            }}<BaseIcon
                icon="pi pi-check-circle"
                :style="{ color: getColorIcon }"
            />
        </h3>
        <div
            class="form-stepper-item__progress"
            :style="{
                '--progress': progress,
                '--color': getColorProgress,
            }"
        ></div>
    </div>
</template>

<style scoped>
.form-stepper-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.875rem;
    flex: 1 0 0;
    h5 {
        color: #092754;
        text-align: center;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 100%;
    }
    h3 {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.625rem;
        align-self: stretch;

        color: #092754;
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
    }

    .form-stepper-item__progress {
        position: relative;
        width: 100%;
        height: 1.5rem;
        background-color: #e3e3e3;
        border-radius: 0.125rem;

        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: calc(100% * (var(--progress) / 100));
            height: 100%;
            background-color: var(--color);
            border-radius: 0.125rem;
        }
    }
}
</style>
